import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyD5E65jKUz0oeLAUAmXcmFO3Rcn93q_lpY",
  authDomain: "kids-qualitytime.firebaseapp.com",
  databaseURL: "https://kids-qualitytime.firebaseio.com",
  projectId: "kids-qualitytime",
  storageBucket: "kids-qualitytime.appspot.com",
  messagingSenderId: "341061536090",
  appId: "1:341061536090:web:0a83df631a75a5ba940b63"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase;
